import React, {useState, useEffect} from 'react'
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar"
import { Link } from 'react-router-dom'
import {
  Pagination,
  Responsive,
} from 'semantic-ui-react'
import "./Bookings.css"
import "./Admin.css"
import PopUp from "../../Components/PopUpForm/ShareProfile-PopUp"
import AdminWrapper from "./AdminWrapper"
import { connect } from "react-redux"
// setCollege, setAllColleges, updateSearchStatus 
//import { setTeacher, setAllTeachers, updateSearchStatus } from "../../redux/admin/admin.actions"
import { setAllCustomers } from "../../redux/admin/admin.actions"
import { API } from "../../API"
import CheckableButton from "../../Components/CheckableButton/CheckableButton"
require("../ValidateDocuments/ValidateDocuments.css")
require("./AllBookings.css")


const AllCustomers = (props) => {
  const [customer, setCustomer] = useState()
  let [pageNum, setPageNum] = useState(1)
  let [showCurrentCustomers, setShowCurrentCustomers] = useState([])
  const [isPopup, togglePopup] = useState(false)
  const [formType, setFormType] = useState("")
  
  // Customer/Institution profile url here
  // const POFILE_URL = `https://master.d2ui2xxezlfztd.amplifyapp.com/NavigateToShareProfile?id=`
  // props for colleges here
  const allCustomers = props.all_custs;

  useEffect(() => {
    API.allCustomers()
      .then((res) => {
        props.setAllCustomers(res.data)
        console.log('custs:: ', res.data)
        console.log('propCusts:: ', allCustomers);
     //   searchForCustomer()
      })
      .catch((err) => {
        console.log(err);
      })
  }, [])

  useEffect(() => {
    searchForCustomer()
  }, [allCustomers])

  const pages = () => {
    let arr = []
    if (allCustomers.length !== 0 && allCustomers.length % 10 === 0) {
      for (let i = 1; i <= allCustomers.length / 10; i++) {
        arr.push(i)
      }
    } else if (allCustomers.length === 0) {
    } else if (allCustomers.length !== 0 && allCustomers.length % 10 !== 0) {
      for (let i = 1; i <= allCustomers.length / 10 + 1; i++) {
        arr.push(i)
      }
    }
    return arr
  }

  // const showShareProfile = (cust) => {

  // }

  let handlePage = (pageNumber, allCustomers) => {
    let currentCustomer = []
    if (allCustomers.length > 0) {
      if (allCustomers.length % 10 === 0) {
        for (
          let i = (pageNumber - 1) * 10;
          i < (pageNumber - 1) * 10 + 10;
          i++
        ) {
          currentCustomer.push(allCustomers[i])
        }
      } else {
        for (
          let i = (pageNumber - 1) * 10;
          i < (pageNumber - 1) * 10 + 10;
          i++
        ) {
          if (i < allCustomers.length) {
            currentCustomer.push(allCustomers[i])
          }
        }
      }

      setShowCurrentCustomers(currentCustomer)
      setPageNum(pageNumber)
    } else {
      setShowCurrentCustomers([])
    }
  }

  // const copyToClipboard = (elementId) => {
    
  // }

  const searchForCustomer = () => {
    let searchItem = []
    if (document.getElementById("institution-name-to-search")) {
      searchItem = document
        .getElementById("institution-name-to-search")
        .value.toLowerCase()
    }

    if (searchItem.length > 0) {
      if (allCustomers.length > 0) {
        let filter_custs = allCustomers.filter((c) => 
          c.first_name === undefined ||
          c.last_name === undefined ||
          c.email === undefined || 
          c.mobile === undefined ||
          c.institution_name === undefined 
          ? null
          : filterCriterias(c).includes(searchItem)
        )

        handlePage(pageNum, filter_custs)
        pages()
      }
    } else {
      handlePage(pageNum, props.all_custs)
      pages()
    }
  }

  const onPageNumChange = (e) => {
    handlePage(e.target.getAttribute('value'), allCustomers)
  }

  const filterCriterias = (c) => {
    let results = ''
    if (c.first_name) results += c.first_name.toLowerCase()
    if (c.last_name) results += c.last_name.toLowerCase()
    if (c.email) results += c.email.toLowerCase()
    if (c.mobile) results += c.mobile.toLowerCase() 
    // let results =
    //   c.first_name.toLowerCase() +
    //   c.last_name.toLowerCase() +
    //   c.email.toLowerCase() + 
    //   c.mobile.toLowerCase() 
    
    if (c.institution_name) results += c.institution_name
    if (c.institution_id) {
      if (c.institution_id.inst_shortname) results += c.institution_id.inst_shortname
      if (c.institution_id.extra_booking_email) results += c.institution_id.extra_booking_email
      if (c.institution_id.institution_name) results += c.institution_id.institution_name
    }

    return results.toLowerCase()
  }

  return (
    <AdminWrapper>
      <div>
        <SwitchMenuBar isViewAsTeacher />
        {/* pop up here? */}
        <div className="auth-right d-lg-flex bg-photoregister">
          <div className="bg-gradient"></div>
          <div className="profile-container mt-4">
            <div className="profile-content-card-area">
              <div className="tab-content clearfix">
                <div className="mt-5">
                  <h1 className="col-12">Manager Customers</h1>
                  <div className="d-flex mt-4 mb-0">
                    <div className="search-label">Search</div>
                    {/* using same id as allTeachers here */}
                    <div className="searchbar" id="all-teachers-search">
                      <input 
                        id="institution-name-to-search"
                        className="search_input"
                        type="text"
                        name=""
                        placeholder="Search..."
                        onChange={(e) => {
                          searchForCustomer()
                          setPageNum(1)
                          // console.log(showCurrentCustomers);
                        }}
                      />
                      <Link
                        onClick={() => {
                          searchForCustomer()
                          // console.log(showCurrentCustomers);
                        }}    
                        pointer={true}
                        className="search_icon font-25"
                      >
                        <i className="mdi mdi-account-search"></i>
                      </Link>
                    </div>
                  </div>
                  <div className="availability-table-container mt-0">
                    <div className="availability-table">
                      <div className="availability-table-header">
                        <div className="availability-table-header-card availability-header-behind"></div>
                        <span
                          id="front-header"
                          className="availability-table-header-card"
                        >
                          <div className="similar-to-h4-style av-table-header-first-line">
                            All Customers
                          </div>
                          <div className=" av-table-header-second-line similar-to-h4-style-1">
                            Details of all customers
                          </div>
                        </span>
                      </div>
                      <div className="availability-table-body mb-0">
                        <div className="availability-table-body-content overflow-auto">
                          <table className="av-tab-root">
                            <thead className="availability-table-head">
                              <tr className="availability-table-head-row">
                                <th className="availability-table-head-cell">
                                  Institution Name
                                </th>
                                <th className="availability-table-head-cell">
                                  Customer Name
                                </th>
                                <th className="availability-table-head-cell">
                                  Email
                                </th>
                                <th className="availability-table-head-cell">
                                  Contact Number
                                </th>
                                <th className="availability-table-head-cell">
                                  Profile
                                </th>
                                <th className="availability-table-head-cell">
                                  Share
                                </th>
                                <th className="availability-table-head-cell">
                                  Hyperlink
                                </th>
                                <th className="availability-table-head-cell">
                                  Details
                                </th>
                                <th className="availability-table-head-cell">
                                  Searchable?
                                </th>
                              </tr>
                            </thead>
                            <tbody className="availability-table-body-bodytable">
                              {showCurrentCustomers.map((user, index) => (
                                <tr
                                  key={index}
                                  className="availability-table-body-row"
                                >
                                  <td
                                    className="availability-table-cell"
                                  >
                                    {user.institution_name}
                                  </td>
                                  <td
                                    value={user._id}
                                    id={user._id}
                                    className="availability-table-cell"
                                  >
                                    {user.first_name} {user.last_name}
                                  </td>
                                  <td className="availability-table-cell small">
                                    {user.email}
                                  </td>
                                  <td className="availability-table-cell">
                                    {user.mobile}
                                  </td>
                                  <td className="availability-table-cell">
                                    Link
                                  </td>
                                  <td className="availability-table-cell">
                                    Link to share profile
                                  </td>
                                  <td className="availability-table-cell">
                                    hyperlink
                                  </td>
                                  <td className="availability-table-cell">
                                    More Details
                                  </td>
                                  <td className="availability-table-cell">
                                    searchable button 
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        <div className="row bookings-bottom pb-0">
                          <div className="col-lg-3 col-md-0 "></div>
                          <div className="col-lg-6  col-md-12 bookings-bottom-pagination">
                            <Responsive minWidth={1500}>
                              <Pagination
                                totalPages={
                                  pages().length > 0 ? pages().length : 1
                                }
                                siblingRange={1}
                                ellipsisItem={false}
                                firstItem={false}
                                lastItem={false}
                                onPageChange={(e) => onPageNumChange(e)}
                                activePage={pageNum}
                              />
                            </Responsive>
                            <Responsive minWidth={1200} maxWidth={1499}>
                              <Pagination
                                totalPages={
                                  pages().length > 0 ? pages().length : 1
                                }
                                ellipsisItem={false}
                                firstItem={false}
                                lastItem={false}
                                boundaryRange={0}
                                siblingRange={1}
                                onPageChange={(e) => onPageNumChange(e)}
                                activePage={pageNum}
                              />
                            </Responsive>
                            <Responsive maxWidth={1199}>
                              <Pagination
                                totalPages={
                                  pages().length > 0 ? pages().length : 1
                                }
                                ellipsisItem={false}
                                firstItem={false}
                                lastItem={false}
                                boundaryRange={0}
                                siblingRange={0}
                                onPageChange={(e) => onPageNumChange(e)}
                                activePage={pageNum}
                              />
                            </Responsive>
                          </div>
                          <div className="col-lg-3 col-md-12"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminWrapper>
  ) 
}

function mapStateToProps(state) {
  return {
    all_custs: state.admin.all_custs
  }
}

const mapDispatchToProps = {
  setAllCustomers,
}

export default connect(mapStateToProps, mapDispatchToProps) (AllCustomers)
